import { Reply } from 'lucide-react';
import type { CustomNodeProps } from '../../types/nodes';
import { BaseNode } from './BaseNode';
import { ResponseConfig } from './ResponseConfig';

export function ResponseNode(props: CustomNodeProps) {
	return (
		<BaseNode
			{...props}
			icon={Reply}
			title="Response"
			description="Formats data for HTTP endpoint responses"
			configComponent={ResponseConfig}
			canHaveOutputs={false} // Response nodes are typically terminal for HTTP endpoints
			colorScheme={{
				light: {
					bg: 'bg-green-50',
					border: 'border-green-200',
					text: 'text-green-700',
					icon: 'text-green-600',
				},
				dark: {
					bg: 'dark:bg-green-900/20',
					border: 'dark:border-green-800',
					text: 'dark:text-green-300',
					icon: 'dark:text-green-400',
				},
			}}
		/>
	);
}
